import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { myAgentProfile } from "../lib/supportWorkspace";

/**
 * Guards /support-workspace/*. Support-agent-ness is layered on top of
 * whatever account a person already has (business owner, employee,
 * platform_admin, or a dedicated invited identity): it is deliberately NOT
 * an account_type, so RequireAuth/RequireRole can't express this gate.
 * Any authenticated user is allowed through to the live check; the backend
 * (support/guards.py::require_support_agent) is the real authority.
 */
export default function RequireSupportAgent({ children }) {
  const { user, loading: authLoading } = useAuth();
  const location = useLocation();
  const [state, setState] = useState({ checked: false, isAgent: false });

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    myAgentProfile()
      .then(() => { if (!cancelled) setState({ checked: true, isAgent: true }); })
      .catch(() => { if (!cancelled) setState({ checked: true, isAgent: false }); });
    return () => { cancelled = true; };
  }, [user]);

  if (authLoading && !user) {
    return (
      <div className="min-h-screen grid place-items-center text-slate-500" data-testid="support-agent-auth-loading">
        Loading…
      </div>
    );
  }
  if (!user) {
    const next = location.pathname + (location.search || "");
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  if (!state.checked) {
    return (
      <div className="min-h-screen grid place-items-center text-slate-500" data-testid="support-agent-check-loading">
        Loading…
      </div>
    );
  }
  if (!state.isAgent) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50 px-4" data-testid="support-agent-denied">
        <div className="max-w-sm text-center rounded-xl border border-slate-200 bg-white p-8">
          <h1 className="font-display text-lg font-semibold text-slate-900 mb-2">Support workspace access required</h1>
          <p className="text-sm text-slate-600">
            Your account doesn&apos;t have an active support-agent role. Ask a ConfirmPH administrator to invite you.
          </p>
        </div>
      </div>
    );
  }
  return children;
}
